import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

export const gettingStartedEntryPoint = createEntryPoint({
	root: JSResourceForInteraction(
		() =>
			import(
				/* webpackChunkName: "async-servicedesk-getting-started-page", jiraSpaEntry: "async-servicedesk-getting-started-page" */ './src'
			),
	),
	getPreloadProps: () => ({}),
});
